define(["require", "exports", "jquery", "../facebookApi", "../context", "../analytics", "./signupCoupon"], function (require, exports, $, facebookApi_1, context_1, analytics_1, signupCoupon_1) {
    "use strict";
    exports.__esModule = true;
    var TAG = 'newsLetter';
    var Actions;
    (function (Actions) {
        Actions[Actions["prompt"] = 0] = "prompt";
        Actions[Actions["fbclick"] = 1] = "fbclick";
        Actions[Actions["emailSignup"] = 2] = "emailSignup";
        Actions[Actions["success"] = 3] = "success";
    })(Actions || (Actions = {}));
    function subscribe(email) {
        var deferred = $.Deferred();
        $.ajax({
            url: "/subscribenewsletter",
            type: "POST",
            data: { "subscribe": true, "email": email }
        }).then(function () {
            analytics_1["default"](TAG, Actions[Actions.success]);
            $.cookie('emailRegistered', 1);
            deferred.resolve(true);
        }).fail(function () {
            deferred.reject();
        });
        return deferred.promise();
    }
    function default_1($anchor, offer) {
        var content = $.extend({
            title: "It's your lucky day",
            body: "Sign up with facebook and get $5 store credit",
            footer: "*First-time buyer only. Certain exclusions apply."
        }, offer);
        var $dlg = $('.subscribe-dialog');
        analytics_1["default"](TAG, Actions[Actions.prompt], null, null, true);
        if ($dlg.length === 0) {
            $dlg = $("<div class=\"subscribe-dialog lock-zoom\"><h3 class=\"title\">" + content.title + "</h3><p>" + content.body + "</p><button class=\"fb-login\">Sign up with Facebook</button><div class=\"ruler\"><span>or</span><hr/></div><form action=\"/login\" method=\"post\"><input type=\"text\" name=\"Email\" placeholder=\"Email\"/><button type=\"submit\" class=\"email-signup\">Sign up</button></form><p class=\"footer\">" + content.footer + "</p></div>");
            if (context_1["default"].isMobile() && $anchor) {
                $dlg.insertAfter($anchor);
            }
            else {
                $dlg.appendTo($('body'));
            }
            var signedUp_1 = $.Deferred();
            $dlg.find('.fb-login').click(function (evt) {
                analytics_1["default"](TAG, Actions[Actions.fbclick]);
                facebookApi_1.logInCeluce().then(function () { return signedUp_1.resolve(true); });
            });
            $dlg.find('.email-signup').click(function (evt) {
                evt.preventDefault();
                evt.stopPropagation();
                analytics_1["default"](TAG, Actions[Actions.emailSignup]);
                var $form = $(evt.currentTarget).closest('form');
                $form.find('input:visible').each(function (i, input) {
                    $(input).toggleClass('error', !$(input).val());
                });
                if ($form.find('input.error').length === 0) {
                    var $button_1 = $(evt.currentTarget);
                    $button_1.text('subscrbing...').prop('disabled', true);
                    subscribe($form.find('input[name="Email"]').val().trim()).then(function () {
                        $dlg.dialog('close');
                        signedUp_1.resolve(true);
                        return $.Deferred().resolve(true);
                    }).always(function () {
                        $button_1.prop('disabled', false);
                        $button_1.text('Sign up');
                    });
                }
            });
            signedUp_1.then(function () {
                signupCoupon_1["default"](offer.coupon, offer.saving, offer.amount);
            });
        }
        if (!context_1["default"].isMobile() || !$anchor) {
            $dlg.dialog('show');
        }
        else {
            $('.master-wrapper-content').toggleClass('blur', true);
        }
    }
    exports["default"] = default_1;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/dialogs/newsletterSubscribe.js
// module id = 76
// module chunks = 0